import React from "react";

import SubmissionsGridItemContent from "./SubmissionsGridItemContent";

import { AssetContainer } from "core/UploadsGrid/styles";

const SubmissionsDeniedItem = ({ submissionData }) => (
    <AssetContainer>
        <SubmissionsGridItemContent submissionData={submissionData} />
    </AssetContainer>
);

export default SubmissionsDeniedItem;
